"use client";

import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

import React from "react";
interface InputBoxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  className?: string;
  mandatory?: boolean;
}

const InputField = React.forwardRef<HTMLInputElement, InputBoxProps>(
  (
    {
      label,
      name,
      type = "text",
      error,
      className,
      mandatory = false,
      required = false,
      ...rest
    },
    ref
  ) => {
    return (
      <div className={cn("space-y-1", type !== "radio" && "w-full")}>
        {label && (
          <Label htmlFor={name} className="!mb-3 ">
            {label}
            {mandatory && <span className="text-red-500">*</span>}
          </Label>
        )}
        <input
          id={name}
          name={name}
          type={type}
          required={required}
          className={cn(
            "w-full border !font-medium border-gray-300 !rounded-[8px] px-3 py-2 text-sm text-gray-900",
            "!ring-0 !outline-none focus:!ring-0 focus:!outline-none focus:!border-gray-300",
            className,
            error && "border-red-500"
          )}
          ref={ref}
          {...rest}
        />

        {error && <p className="!text-12 text-red-500">{error}</p>}
      </div>
    );
  }
);

InputField.displayName = "InputField";

export default InputField;
